import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UncontrolledCollapse } from "reactstrap";
import { FaServer, FaPlusCircle } from "react-icons/fa";

import WebAddLiteServer from "./WebAddLiteServer";
import WebLiteServerList from "./list/WebLiteServerList";
import WebPagination from "../etc/WebPagination";

const WebLiteServerConfig = ({ selectedSubDomainInfo, list_configLiteServer, handleSelectedFunc }) => {
    const { t } = useTranslation();

    // 한 페이지에 보여줄 개수 (10/20/30/50/100 선택 가능)
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [offset, setOffset] = useState((page - 1) * limit);
    const [blockNum, setBlockNum] = useState(0);

    // 컴포넌트 초기 로드 여부를 추적하는 상태 추가
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    const [isAddLiteServerOK, setIsAddLiteServerOK] = useState(false);

    useEffect(() => {
        // console.log("WebLiteLocalServerConfig visible");

        handleSelectedFunc({ selectedFunc: "GET_LITE_SERVER_LIST" });

        return () => {
            // console.log("WebLiteLocalServerConfig invisible");

            // 컴포넌트가 언마운트될 때 초기화
            setIsFirstLoad(true);
        }
    }, []);

    useEffect(() => {
        let offset = (page - 1) * limit;
        setOffset(offset);
    }, [page, limit]);

    useEffect(() => {
        setIsAddLiteServerOK(true);

        // 초기 로드 시에만 페이지를 1로 설정하고, 이후에는 현재 페이지 유지
        if (isFirstLoad) {
            setPage(1);
            setOffset((page - 1) * limit);
            setIsFirstLoad(false);
        }

        /* return () => {
            setPage(1);
            setOffset((page - 1) * limit);
        } */
    }, [list_configLiteServer, page, isFirstLoad]);

    const onChangeIsAddLiteServerOK = () => {
        setIsAddLiteServerOK(!isAddLiteServerOK);
    }

    return (
        // teacher/class 탭과 동일한 app-container / main-title-bar / btn-top-register 스타일 적용
        // (기존 로직·핸들러·props는 그대로 유지, 마크업/className만 교체)
        <div className="web-main admin list-area">
            <div className="app-container">
                <div className="main-title-bar">
                    <div className="title-left">
                        <FaServer className="icon-teacher" aria-hidden="true" />
                        <span className="title-text">{t("라이트_로컬_서버", { ns: "admin" })}</span>
                        <button type="button" className="btn-top-register" id="addLiteLocalServer">
                            <FaPlusCircle aria-hidden="true" />{t("라이트_로컬_서버_등록", { ns: "admin" })}
                        </button>
                    </div>
                </div>
                <UncontrolledCollapse toggler="#addLiteLocalServer" defaultOpen={false}>
                    <WebAddLiteServer
                        selectedSubDomainInfo={selectedSubDomainInfo}
                        isAddLiteServerOK={isAddLiteServerOK}
                        onChangeIsAddLiteServerOK={onChangeIsAddLiteServerOK}
                        handleSelectedFunc={handleSelectedFunc}
                    />
                </UncontrolledCollapse>
                <WebPagination
                    total={list_configLiteServer.length <= 0 ? 1 : list_configLiteServer.length}
                    limit={limit}
                    setLimit={setLimit}
                    page={page}
                    setPage={setPage}
                    blockNum={blockNum}
                    setBlockNum={setBlockNum}
                />
                <WebLiteServerList
                    currentPage={page}
                    // list_liteServer={list_configLiteServer}
                    list_liteServer={list_configLiteServer.slice(offset, offset + limit)}
                    handleSelectedFunc={handleSelectedFunc}
                />
            </div>
        </div>
    )
};
export default WebLiteServerConfig;
